module.exports = __webpack_public_path__ + "static/img/High-frequency PU Processing2.120dbab3.jpg";